module.exports = __webpack_public_path__ + "static/media/sora_defaultfb4c63272ecf8795a42216f062013435.webp";